import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { RsMotionService } from './rs-motion';

/**
 * Publishes normalised pointer coordinates as `--px` / `--py` on the host and
 * pauses ambient CSS animations while the host is off-screen.
 *
 * This is the same behaviour the approved hero uses, extracted so any section
 * built from `.rs-section` + `.rs-deco` gets the drifting blobs for free.
 */
@Directive({
  selector: '[rsParallax]',
  standalone: true,
})
export class RsParallaxDirective implements AfterViewInit, OnDestroy {
  private cleanups: Array<() => void> = [];

  constructor(private host: ElementRef<HTMLElement>, private motion: RsMotionService) {}

  ngAfterViewInit(): void {
    const el = this.host.nativeElement;
    this.cleanups.push(this.motion.trackPointer(el), this.motion.pauseOffscreen(el));
  }

  ngOnDestroy(): void {
    this.cleanups.forEach((fn) => fn());
    this.cleanups = [];
  }
}
